export function changeGleapBlockVisibility(visibility: 'visible' | 'hidden') {
  document.querySelectorAll('.gl-block').forEach((el) => {
    (el as HTMLElement).style.visibility = visibility;
  });
}
